/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

export {CdkAccordionItem} from './accordion-item';
export {CdkAccordion} from './accordion';
export * from './accordion-module';



// WEBPACK FOOTER //
// ../../../../../src/cdk/accordion/public-api.ts